import IMAGES from "@/public/assets/img";

const machineryFinancing = {
    seoData: {
        title: "Machinery & Capex Financing for Businesses in India | Apply Online",
        description:
          "Get machinery and capex financing for your business. Fund industrial equipment, production machinery, and capital expenditure with flexible repayment options.",
      },
      bannerHeading: `<span class="text-heading font-medium sm:text-xl">Industrial Machinery Loans</span><br/> <span class="font-medium text-headingbig sm:text-heading3">Up to ₹10 Crore</span>`,
      subheading: "Fund plant expansion, automation & imported equipment",
      btntext: "with structured capex financing in 72 hours",    
   
  loanInfo: [
    {
      icon: IMAGES.machineryFinancing.cash,
      description: "Up to 90% LTV (equipment-backed)",
    },
    {
      icon: IMAGES.machineryFinancing.import,
      description: "Import linked structuring available",
    },
    {
      icon: IMAGES?.machineryFinancing.fatser,
      description: "Faster sanction than traditional banks",
    },
  ],

  benefits: [
    {
      id: 1,
      icon: IMAGES?.dealerFinancing.RBILogo,
      text: "RBI-licensed NBFC platform ",
    },
    {
      id: 2,
      icon: IMAGES?.dealerFinancing.msme,
      text: "Trusted by 2,500+ enterprises & MSMEs ",
    },
    {
      id: 3,
      icon: IMAGES?.dealerFinancing.cities,
      text: "Active across 120+ cities ",
    },
    {
      id: 4,
      icon: IMAGES?.dealerFinancing.ERP,
      text: "Integrated with ERP & dealer networks ",
    },
  ],

  industrialData: {
    heading: '<span class="text-baseBlack">Why Industrial Capex</span> <span class="text-yellow-400">Gets Delayed?</span>',
    imageClock: IMAGES.machineryFinancing.watchImage,
    capexBg: IMAGES.machineryFinancing.capesBg,
    Industrial: [
      {
        id: 1,
        image: IMAGES?.machineryFinancing.realTime,
        text: "Heavy Upfront Costs​",
      },
      {
        id: 2,
        image: IMAGES?.machineryFinancing.detailReport,
        text: "Slow Bank Bureaucracy​",
      },
      {
        id: 3,
        image: IMAGES?.machineryFinancing.indepth,
        text: "Depleted Working Capital",
      },
    ],
  },

  eligibleMachinery: {
    heading: "Eligible Industrial Machinery",
    whySection: [
      {
        id: 1,
        image: IMAGES?.machineryFinancing.engineering,
        text: "CNC & Engineering​",
      },
      {
        id: 2,
        image: IMAGES?.machineryFinancing.molding,
        text: "Injection Molding​",
      },
      {
        id: 3,
        image: IMAGES?.machineryFinancing.packing,
        text: "Printing & Packaging",
      },
      {
        id: 4,
        image: IMAGES?.machineryFinancing.textile,
        text: "Textile Machinery​",
      },
      {
        id: 5,
        image: IMAGES?.machineryFinancing.semiconductor,
        text: "Electronics & Semiconductor​",
      },
      {
        id: 6,
        image: IMAGES?.machineryFinancing.construction,
        text: "Construction Equipment",
      },
    ],
  },

  HowItWorks: {
    sectionTitle: "How it Works",
    whySection: [
      {
        id: 1,
        text: "Submit Machinery Quote",
        color: "#5AC1A9"
      },
      {
        id: 2,
        text: "Credit & Technical Evaluation",
        color: "#2D8AC7"
      },
      {
        id: 3,
        text: "Sanction within 72 Hours",
        color: "#F5A623"
      },
      {
        id: 4,
        text: "Vendor Payment",
        color: "#E96A78"
      },
      {
        id: 5,
        text: "Flexible EMI Structure ",
        color: "#4CC3C7"
      }
    ]
  },

  ConuterSec:{
    heading:'Built for Industrial Growth',
    bannerImg : IMAGES.HomeNew.numbersBg,
    bannerMbImage:IMAGES.HomeNew.numbersBgMobile,
    counterList:[
        {heading:'75,000', paragraph:'Invoice Funded', smalltext:'+'},
        {heading:'5000', paragraph:'MSMEs Onboarded', smalltext:'+'},
        {heading:'$1', paragraph:'Export Financing', smalltext:'Bn+'},
        {heading:'120', paragraph:'Cities Coverage', smalltext:'+'}
    ]
},

GlobalNetwork:{
  heading:'Our <strong>Global Network</strong> <br/>Enable Faster Results',
  para:'With offices in India, USA, UAE, and Mexico regions, Credlix offers localized support and expertise to clients worldwide.',
  flags:[
    {flag:IMAGES.HomeNew.indiaFlag,name:'India'},
    {flag:IMAGES.HomeNew.mexicoFlag,name:'Mexico'},
    {flag:IMAGES.HomeNew.singaporeFlag,name:'Singapore'},
    {flag:IMAGES.HomeNew.usaFlag,name:'USA'},
    {flag:IMAGES.HomeNew.uaeFlag,name:'UAE'},
  ]
},

  comparisonData: {
    bgBanner: IMAGES.dealerFinancing.featureBg,
    title: "Why Credlix Over Banks?",
    parameters: [
      "Approval Timeline",
      "Collateral Requirement",
      "Flexibility",
      "Process",
    ],
    options: [
      {
        title: "Credlix Machinery Loans",
        highlight: true,
        values: [
          { text: "≤ 48 hours", check: true },
          { text: "None", check: true },
          { text: "30–90 day tenor", check: true },
          { text: "100% digital", check: true },
        ],
      },
      {
        title: "Traditional Banks",
        highlight: false,
        values: [
          { text: "7-14 Days", check: false },
          { text: "Cash margin or collateral", check: false },
          { text: "Fixed L/C terms", check: false },
          { text: "Manual document handling", check: false },
        ],
      },
    ],
  }, 

  FaqHead: "Frequently Asked Questions",
  Faq: [
    {
      id: 0,
      question: "What are the prevailing interest rates and terms for industrial machinery loans at Credlix?",
      answers:
        "Credlix offers competitive interest rates, tailored to the type of machinery and the borrower’s credit profile. We provide loan amounts from ₹50 Lakh up to ₹10 Crore, with tenures ranging from 12 to 72 months to align with the asset’s useful life and ROI.",
    },
    {
      id: 1,
      question: "Can Credlix provide financing for imported industrial machinery? ",
      answers: "Yes.We offer up to 90% LTV on imported units, covering a significant portion of the upfront cost.",
    },
    {
      id: 2,
      question: "Is additional collateral required for a Credlix machinery loan?",
      answers:
        "In most cases, the machinery loan is equipment-backed, meaning the machine itself acts as the primary security. Additional property collateral is rarely needed for standard industrial machinery and businesses with a strong operational track record. This allows manufacturers to expand their production capacity without tying up their other fixed assets.",
    },
    {
      id: 3,
      question: "How fast is the loan sanction and disbursement process for capex requirements?",
      answers: "We understand that manufacturing growth is time-sensitive. Credlix provides a formal loan sanction within 72 hours of document submission. Vendor payment or LC setup is typically completed within 5 to 7 working days, ensuring your machinery is ordered and installed with minimal delay.",
    },
    {
      id: 4,
      question: "Which types of industrial machinery and sectors are eligible for financing?",
      answers: "Credlix finances a wide range of productive assets across sectors, including CNC and engineering, injection molding, printing and packaging, textile machinery, electronics and semiconductor equipment, and construction machinery. Whether you are buying new or imported equipment, we have dedicated programs to support your specific manufacturing vertical.",
    },
    {
      id: 5,
      question: "What are the primary benefits of taking a machinery loan over using working capital?",
      answers: "Utilizing a dedicated machinery loan preserves your working capital for day-to-day operations and provides a structured repayment plan that matches the machine’s production output.",
    },
    {
      id: 6,
      question: "Can startups or newly established manufacturing units apply for machinery finance?",
      answers: "Yes. While we prefer a business vintage of at least 3 years, We assess the feasibility of the production plan and the viability of the machinery in the current market to provide financing solutions for growth-stage companies.",
    },
  ],
};
export default machineryFinancing;
